import { formatDateRange } from '@modules/common/components/DateRangePicker/helpers/formatDateRange';
import { DateRange } from '@mui/x-date-pickers-pro';
import { Dayjs } from 'dayjs';

export const getDateRangeString = (dateRange: DateRange<Dayjs>) => {
  if (!dateRange[0] || !dateRange[1]) {
    return '';
  }

  return formatDateRange(dateRange[0], dateRange[1]);
};
